export default function ExperienceIco() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#FFDCE8" />
      <path
        d="M12 16.6667V11.3334"
        stroke="#FA4F96"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M8.66602 16.6667V14"
        stroke="#FA4F96"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M15.334 16.6667V8"
        stroke="#FA4F96"
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  );
}
